import EventBookingGeoRestrictionsGeneralInformationEditModel
    from '@modules/events/forms/EventBookingGeoRestrictions/EventBookingGeoRestrictionsGeneralInformationEditModel';
import {GetInvoiceStatuses} from '@graphql/invoiceStatus/query';

export default function ClientBookingGeoRestrictionsGeneralInformationEditModel() {
    let ClientBookingGeoRestrictionsGeneralInformationEditModel = EventBookingGeoRestrictionsGeneralInformationEditModel();

    ClientBookingGeoRestrictionsGeneralInformationEditModel.messages.boxName = {
        delete: 'clientMessage',
        error: 'clientMessage',
        success: 'clientMessage',
    };
    ClientBookingGeoRestrictionsGeneralInformationEditModel.mutationOptions = {
        delete: {
            refetchQueries: ['clientBookingsForTable'],
        },
        update: {
            refetchQueries: ['clientBookingsForTable'],
        },
    };
    ClientBookingGeoRestrictionsGeneralInformationEditModel.query.getOptions = GetInvoiceStatuses;

    return ClientBookingGeoRestrictionsGeneralInformationEditModel;
}
